import React, { useState } from "react";
import { Box, IconButton, Tabs, Tab, Grid } from "@mui/material";

const emojiCategories = {
  "Carinhas": ["😀", "😁", "😂", "🤣", "😃", "😄", "😅", "😆", "😉", "😊", "😋", "😎", "😍", "😘", "🥰", "😗", "😙", "😚"],
  "Animais": ["🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵"],
  "Comidas": ["🍎", "🍊", "🍌", "🍉", "🍇", "🍓", "🥝", "🍍", "🥭", "🍒", "🍑", "🥑", "🍆", "🌽", "🥕", "🥔"],
  "Atividades": ["⚽", "🏀", "🏈", "⚾", "🎾", "🏐", "🎱", "🏓", "🏸", "🏒", "🥌", "⛷️", "🏂", "🏄", "🏊", "🚴", "🚵"],
  "Viagens": ["🚗", "🚕", "🚙", "🚌", "🚎", "🏎️", "🚓", "🚑", "🚒", "🚐", "🛻", "🚚", "🚜", "✈️", "🚂", "🚢"],
};

const emojiTabs = Object.keys(emojiCategories);

const EmojiPicker = ({ onSelectEmoji }) => {
  const [activeTab, setActiveTab] = useState(emojiTabs[0]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        maxWidth: "350px",
        maxHeight: "400px",
        overflow: "hidden",
        backgroundColor: "#fff",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        borderRadius: "8px",
      }}
    >
      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #ddd",
        }}
      >
        {emojiTabs.map((tab) => (
          <Tab
            key={tab}
            label={tab}
            value={tab}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#333",
              "&.Mui-selected": {
                color: "#1976d2",
              },
            }}
          />
        ))}
      </Tabs>

      {/* Emoji Grid */}
      <Box
        sx={{
          overflowY: "auto",
          maxHeight: "350px",
          p: 2,
        }}
      >
        <Grid container spacing={1}>
          {emojiCategories[activeTab].map((emoji, index) => (
            <Grid item xs={3} key={index}>
              <IconButton
                onClick={() => onSelectEmoji(emoji)}
                sx={{
                  fontSize: "24px",
                  color: "inherit", // Mostra a cor normal do emoji
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                  },
                }}
              >
                {emoji}
              </IconButton>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default EmojiPicker;
